import * as React from 'react';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import Translate from '../../common/functions/translate';
import Dialog from '@material-ui/core/Dialog';
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import * as Modal from '../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import Spinner from '../../common/components/spinner/spinner';
import Snackbar from "../../common/components/snackbar/snackbar";
import UserService from '../../services/userService';
import { UserModel } from '../../models/user';
import { EditProfileModel } from '../../models/user/editProfileModel';


interface IProps {
    cancelClick: any;
    onSuccessEdit: any;
    isVisible: boolean;
    currentUser: UserModel;
}

interface IState {
    isLoading: boolean;
    user: UserModel;
    validationMessage: string;
}

const theme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 5,
                marginBottom: 0,
                width: '100%'
            },
            root: {
                width: '100%'
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: '0px'
            }
        },
        MuiDialog: {
            paper: {
                margin: 0,
                maxWidth: '50% !important'
            },
            paperFullWidth: {
                width: '70%'
            }
        },
    },
    palette: {
        primary: blue
    }
})

class EditUserInfoDialog extends React.Component<IProps, IState> {
    snackbar: any;;
    userService = new UserService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            validationMessage: '',
            user: this.props.currentUser
        };
    }

    componentDidMount() {

    }

    isEditUserInfoFormIsValid = () => {
        this.setState({ validationMessage: '' });
        const { user } = this.state;
        let message = '';

        if (!user.name) {
            message += Translate('Please enter name') + '<br />';
        }

        this.setState({
            validationMessage: message
        });

        return message === '';
    }

    handleChange = (key, value) => {
        const user: UserModel = { ...this.state.user };
        user[key] = value;
        this.setState({ user: { ...user } });
    };

    handleSaveButton = () => {
        if (!this.isEditUserInfoFormIsValid()) return;

        const { user } = this.state;

        this.setState({
            isLoading: true
        });

        let editProfileModel = new EditProfileModel();
        editProfileModel.userId = user.userId;
        editProfileModel.name = user.name;
        editProfileModel.phone = user.phone;

        this.userService.editProfile(editProfileModel).then(
            (result) => {
                this.setState({
                    isLoading: false,
                    validationMessage: ''
                }, () => this.props.onSuccessEdit())
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    validationMessage: error.message
                })
            });
    }

    handleCancelButton = () => {
        this.setState({
            validationMessage: ''
        })
        this.props.cancelClick();
    }

    public render() {

        const { validationMessage, user, isLoading } = this.state;

        return (
            <MuiThemeProvider theme={theme}>
                <Dialog
                    open={this.props.isVisible}
                    onClose={this.handleCancelButton}
                    fullWidth
                    disableBackdropClick={true}
                >
                    <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{Translate('Edit user data')}</Modal.DialogTitle>
                    <Modal.DialogContent>
                        {isLoading ? <Spinner /> : null}
                        <Snackbar ref={(el) => this.snackbar = el} />
                        <div>
                            {validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <TextField
                                name="name"
                                label={Translate('Name')}
                                type="text"
                                onChange={(e) => this.handleChange('name', e.target['value'])}
                                value={user && user.name ? user.name : ""}
                                style={{ width: 50 + '%', marginTop: 10 }}
                            />

                            <TextField
                                name="phone"
                                label={Translate('Phone')}
                                type="text"
                                onChange={(e) => this.handleChange('phone', e.target['value'])}
                                value={user && user.phone ? user.phone : ""}
                                style={{ width: 50 + '%', marginTop: 10 }}
                            />
                        </div>
                    </Modal.DialogContent>
                    <Modal.DialogActions>
                        <div>
                            <Button onClick={this.handleCancelButton} variant="contained" style={{ marginRight: 10 }}>
                                {Translate("Cancel")}
                            </Button>
                            <Button onClick={() => this.handleSaveButton()} color="primary" variant="contained">
                                {Translate("Save")}
                            </Button>
                        </div>
                    </Modal.DialogActions>
                </Dialog >
            </MuiThemeProvider>
        )
    }
}

export default EditUserInfoDialog;